import {BufferGeometry, Color, Float32BufferAttribute, LineBasicMaterial, LineSegments} from "three";

class GridHelper2 extends LineSegments {

    constructor( step_w, step_h, size = 1, color = 0x444444 ) {
        color = new Color( color );

        const width  = step_w * size;
        const height = step_h * size;

        const vertices = [], colors = [];

        let k = 0;
        for (let x = -width/2, i = 0; i <= step_w; i++, x += size) {
            let y = -height/2;
            vertices.push(x, 0, y);
            vertices.push(x, 0, y+height);
            color.toArray( colors, k ); k += 3;
            color.toArray( colors, k ); k += 3;
        }
        for (let y = -height/2, j = 0; j <= step_h; j++, y += size) {
            let x = -width/2;
            vertices.push(x, 0, y);
            vertices.push(x+width, 0, y);
            color.toArray( colors, k ); k += 3;
            color.toArray( colors, k ); k += 3;
        }

        const geometry = new BufferGeometry();
        geometry.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
        geometry.setAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

        const material = new LineBasicMaterial( { vertexColors: true, toneMapped: false } );

        super( geometry, material );

        this.type = 'GridHelper2';
    }
}

export { GridHelper2 }
